import { BASE_URL } from '../Config';
import { BASE_URL2 } from '../Config';

/**
 * API 요청 함수
 * @param {string} endpoint - API 경로
 * @param {string} method - HTTP 메서드 (GET, POST 등)
 * @param {object} [data] - 요청에 포함할 데이터 (POST, PUT 등에서 사용)
 * @returns {Promise<object>} - 서버 응답 데이터
 */
export const apiRequest = async (endpoint, method = 'GET', data = null) => {
  try {
    let url = `${BASE_URL}${endpoint}`;

    const isFakeFormData = data && data.__IS_FORMDATA__;

    // GET 요청일 경우
    if (method === 'GET' && data && !isFakeFormData) {
      const queryParams = new URLSearchParams(data).toString();
      url += `?${queryParams}`;
    }

    const options = {
      method,
      headers: {},
    };

    if (data && method !== 'GET') {
      if (isFakeFormData && data.formData instanceof FormData) {
        // FormData인 경우 → headers 설정하지 않음
        options.body = data.formData;
      } else {
        // 일반 JSON인 경우
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(data);
      }
    }

    const response = await fetch(url, options);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Server Error: ${errorText}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Error in ${method} request to ${endpoint}:`, error);
    throw error;
  }
};

/**
 * NFC 전용 요청 함수 (포트 30022)
 * @param {string} endpoint - API 경로 (예: '/nfc/latest')
 * @param {string} method - HTTP 메서드
 * @param {object} [data] - 요청에 포함할 데이터
 * @returns {Promise<object>} - 응답 데이터
 */
export const nfcRequest = async (endpoint, method = 'GET', data = null) => {
  try {
    let url = `${BASE_URL2}${endpoint}`;

    const isFakeFormData = data && data.__IS_FORMDATA__;

    // GET 요청에 쿼리 추가
    if (method === 'GET' && data && !isFakeFormData) {
      const queryParams = new URLSearchParams(data).toString();
      url += `?${queryParams}`;
    }

    const options = {
      method,
      headers: {},
    };

    if (data && method !== 'GET') {
      if (isFakeFormData && data.formData instanceof FormData) {
        options.body = data.formData;
      } else {
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(data);
      }
    }

    const response = await fetch(url, options);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`NFC Server Error: ${errorText}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Error in ${method} request to NFC ${endpoint}:`, error);
    throw error;
  }
};

